export default __webpack_public_path__ + "static/media/GIS-main.7edaab96.jpg";